import { SubAccount } from 'redux/ducks/subAccounts/types';
import { RootState } from 'redux/rootReducer';
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash/isEqual';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

// pointless, should be handled at the 'edge' ui view
const parseAccounts = (accounts: SubAccount[] = [], useNickname: boolean) =>
  accounts
    .map((account) => ({
      nickname: account.nickname,
      name: useNickname ? account.nickname || account.name : account.name,
      id: account.id
    }))
    .sort((a, b) => (a['name'] < b['name'] ? -1 : 1));

const useNicknameSelector = (state: RootState) => state.settings.useAccountNickname;
const subscribedSelector = (state: RootState) => state.subAccounts.subscribed;

export const selectSubscribedAccounts = createDeepEqualSelector(
  useNicknameSelector,
  subscribedSelector,
  (useNickname, subscribed) => {
    return parseAccounts(subscribed, useNickname);
  }
);
